
<template>
  <div>
    <section class=" dark" style="padding-top: 10px">
            <form id="form-checkout-se">
              <div class="row">
                <div class="col s12">
                  <input placeholder="Nome no cartão" name="softwareExpressNome" type="text" id="softwareExpressNome"/>
                </div>
                <div class="col s12">
                  <input type="tel" @blur="updateCardBrand" placeholder="Número de identificação" name="softwareExpressNumero" id="softwareExpressNumero" />
                </div>
                <div class="col s7">
                  <the-mask type="tel" :mask="['##/##']" placeholder="Mês/Ano" name="softwareExpressMesAno" id="softwareExpressMesAno"/>
                </div>
                <div class="col s5">
                  <the-mask type="tel" :mask="['###']" placeholder="CVC" name="softwareExpressCVC" id="softwareExpressCVC"/>
                </div>
                <div class="col s12" >
                  <select class="browser-default" name="softwareExpressBandeira" id="softwareExpressBandeira" v-model="cardBrand">
                    <option value="" disabled selected>Selecione a bandeira do cartão</option>
                    <option value="1">Visa</option>
                    <option value="2">MasterCard</option>
                    <option value="33">Diners</option>
                    <option value="3">Amex (American Express)</option>
                  </select>
                </div>
              </div>
            </form>
    </section>
  </div>
</template>
<script >
export default {
  name: "SoftwareExpressCheckoutTransparente",
  data() {
    return {
      cardBrand: '',
    }
  },
  methods:{
    updateCardBrand(event) {
      const cardNumber = event.target.value;

      if(cardNumber.length > 12)
        this.cardBrand = this.getCardBrand(cardNumber);
    },
    getCardBrand(cardNumber) {
        cardNumber = cardNumber.replace(/[\s-]/g, '');
        const bin = cardNumber.substring(0, 6);
        if (/^4[0-9]{5}/.test(bin)) {
            return '1';//'Visa';
        } else if (/^5[1-5][0-9]{4}/.test(bin) || /^2(2[2-9][0-9]|[3-7][0-9]{2}|80[0-9]{2})/.test(bin)) {
            return '2';//'MasterCard';
        } else if (/^3[47][0-9]{4}/.test(bin)) {
            return '3';//'American Express';
        } else if (/^3(?:0[0-5][0-9]{3}|[68][0-9]{4})/.test(bin)) {
            return '33';//'Diners';
        } else {
            return '';
        }
    }
  },
  mounted() {
    $(document).ready(function(){
      $('select').formSelect();
    });
  },
}
// 1	VISA
// 2	MASTERCARD
// 3	AMERICAN EXPRESS
// 41 ELO

        // } else if (/^6(?:011|22[1-9][0-9]|4[4-9][0-9]|5[0-9]{2})/.test(bin)) {
        //     return '';//'Discover';
        // } else if (/^3(?:0[0-5]|[68][0-9])[0-9]{3}/.test(bin)) {
        //     return ''; //'Diners Club';
        // } else if (/^(?:2131|1800|35[2-8][0-9]{3})/.test(bin)) {
        //     return '';//'JCB';
        // } else if (/^6(0[4-5]|389)[0-9]{3}/.test(bin)) {
        //     return '';//'Cabal';
        // } else if (/^((401178|401179|431274|438935|457631|457632|504175|627780|636297|636368|650031|650033|650035|650036|65004[0-9]|65005[0-9]|65040[5-9]|65048[5-9]|65049[0-9]|65051[0-9]|65052[1-9]|65053[0-8]|65054[1-9]|65055[0-9]|65056[1-9]|65057[0-8]|65072[0-9]|65090[1-9]|65091[0-9]|65092[1-9]|65093[0-9]|65094[1-9]|65095[0-9]|65164[0-9]|65165[2-9]|65166[0-9]|65167[0-9]|65168[0-4]|65169[0-3]|65500[0-9]|65501[0-9]|65502[1-9]|65503[0-9]|65504[0-9]|65505[0-9]))/.test(bin)) {
        //     return '';//'Elo';
</script>



// WEBPACK FOOTER //
// src/app/components/Widgets/SoftwareExpressCheckoutTransparente.vue